import { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '@/pages/Dashboard';
import EditorPresupuesto from '@/pages/EditorPresupuesto';
import PreviewPresupuesto from '@/pages/PreviewPresupuesto';
import Configuracion from '@/pages/Configuracion';
import Clientes from '@/pages/Clientes';
import ProductosServicios from '@/pages/ProductosServicios';
import Manual from '@/pages/Manual';
import Login from '@/pages/Login';
import { isSessionValid } from '@/lib/auth';

function App() {
  const [authenticated, setAuthenticated] = useState<boolean>(isSessionValid());

  useEffect(() => {
    // Recheck session every minute
    const id = setInterval(() => {
      if (!isSessionValid()) setAuthenticated(false);
    }, 60_000);
    return () => clearInterval(id);
  }, []);

  if (!authenticated) {
    return <Login onSuccess={() => setAuthenticated(true)} />;
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/editor/:id" element={<EditorPresupuesto />} />
        <Route path="/preview/:id" element={<PreviewPresupuesto />} />
        <Route path="/configuracion" element={<Configuracion />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/productos" element={<ProductosServicios />} />
        <Route path="/manual" element={<Manual />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
